import omit from 'lodash/omit';

export function allIds(state, action) {
  const { itemIds } = action.payload;
  const newList = state.filter(givenId => itemIds.indexOf(givenId) === -1);
  return [...newList];
}

export function byId(state, action) {
  const { itemIds } = action.payload;
  let newState = { ...state };

  itemIds.forEach((givenId) => {
    newState = omit(newState, givenId);
  });

  return { ...newState };
}
